import React, { FC } from 'react';
import { ComingNomenclatureFare } from 'bus/comingNomenclatureMain/types';

type Props = Omit<ComingNomenclatureFare, 'data'> & {
    dateBegin: string;
    dateEnd: string;
};

const DetailTaskInfo: FC<Props> = ({
    adjustments,
    balance,
    pay,
    toPay,
    dateBegin,
    outBalance,
    dateEnd
}) => {
    return (
        <div className="d-flex">
            <div className="dx-card pl-2 pr-2 pb-2 mb-3 mr-2" style={{ width: 450 }}>
                <div className="info">
                    <div className="info__title">Остаток на {dateBegin}</div>
                    <div className="info__child">{ balance }</div>
                </div>
                <div className="info">
                    <div className="info__title">Оплачено</div>
                    <div className="info__child">{ pay }</div>
                </div>
                <div className="info">
                    <div className="info__title">Оклад</div>
                    <div className="info__child">{ toPay }</div>
                </div>
                <div className="info">
                    <div className="info__title">Корректировка</div>
                    <div className="info__child">{ adjustments }</div>
                </div>
                <div className="info">
                    <div className="info__title">К оплате на {dateEnd}</div>
                    <div className="info__child">{ outBalance }</div>
                </div>
            </div>
        </div>
    );
}

export default DetailTaskInfo;
